export const DIALOG_GRAPHIC_BASE_FOLDER = '图片/UI'
export const IMAGE_OPTION_GRAPHIC_BASE_FOLDER = '图片/button'
export const PAYMENT_GRAPHIC_BASE_FOLDER = '图片/UI'
export const TITLE_BACKGROUND_BASE_FOLDER = '图片/背景'
export const SETTINGS_BACKGROUND_BASE_FOLDER = '图片/UI'
export const TITLE_MUSIC_BASE_FOLDER = '音频/音乐'
export const MAX_MALL_GOODS_COUNT = 48
export const MALL_GOODS_PER_PAGE = 6
export const TITLE_BUTTON_LABELS = ['开始', '读取进度', 'CG鉴赏', 'BGM鉴赏', '设置', '离开']
export const MENU_BUTTON_LABELS = ['存档', '读档', '回放', '自动', '设置', '返回']
export const SYSTEM_BUTTON_DEFS = [
  { key: 'Close', label: '关闭按钮', flag: null },
  { key: 'Title', label: '返回标题', flag: 'IsTitle' },
  { key: 'AutoText_on', label: '自动开', flag: 'IsAutoText' },
  { key: 'AutoText_off', label: '自动关', flag: 'IsAutoText' },
  { key: 'FullScreen', label: '全屏显示', flag: 'IsFullScreen' },
  { key: 'WinScreen', label: '窗口显示', flag: 'IsFullScreen' },
] as const
export const SYSTEM_AUDIO_DEFS = [
  { key: 'BGM', label: '音乐' },
  { key: 'SE', label: '音效' },
  { key: 'Voice', label: '语音' },
] as const
